import { IPromise, IQService } from "angular";
import { clone, cloneDeep } from "lodash";
import {
  IHasResponseStatus,
  ServiceResponse,
} from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { CloneMachineResponse, Machine } from "../models/machine";
import { MachineConfiguration } from "../models/machineConfiguration";
import { ProgressiveDefinition } from "../models/progressiveDefinition";

export const vsName = "cloneAndConversionService";

export class CloneAndConversionService {
  static $inject = [ServerUtilityName, "$q"];

  constructor(
    private readonly serverUtility: ServerUtility,
    private readonly $q: IQService
  ) {}

  getConversionConfiguration(
    currentConfiguration: MachineConfiguration,
    modelMachineId: number,
    modelConfigurationId: number
  ): IPromise<MachineConfiguration> {
    return this.getCloneConfiguration(
      modelMachineId,
      modelConfigurationId
    ).then((cloneMachineResponse) => {
      const conversionConfiguration = cloneMachineResponse.Configuration;
      conversionConfiguration.SlotNumber = currentConfiguration.SlotNumber;
      conversionConfiguration.MachineBank = currentConfiguration.MachineBank;
      conversionConfiguration.MachineBankId =
        currentConfiguration.MachineBankId;
      conversionConfiguration.Position = currentConfiguration.Position;
      conversionConfiguration.WarehouseLocation =
        currentConfiguration.WarehouseLocation;

      conversionConfiguration.Date = undefined;

      return conversionConfiguration;
    });
  }

  private cleanCloneConfiguration(configuration: MachineConfiguration) {
    configuration.SlotNumber = undefined;
    configuration.Position = undefined;
    configuration.WarehouseLocation = undefined;
  }

  private cleanCloneMachine(machine: Machine) {
    machine.SerialNumber = undefined;
  }

  getProgressiveDefinition(
    progressiveDefinitionId?: number
  ): IPromise<ProgressiveDefinition | undefined> {
    if (progressiveDefinitionId === undefined) return this.$q.when(undefined);

    return this.serverUtility
      .getById<ServiceResponse<ProgressiveDefinition>>({
        url: `/api/machines/progressives/ProgressiveDefinition`,
        id: progressiveDefinitionId,
      })
      .then((response) => response.Result);
  }

  getCloneConfiguration(
    machineId: number,
    machineConfigurationId?: number
  ): IPromise<CloneMachineResponse> {
    return this.serverUtility
      .sendApiRequest<CloneMachineResponse>({
        url: `/api/machines/${machineId}/clone`,
        method: "get",
        params: {
          machineConfigurationId,
        },
      })
      .then((response) => {
        const cloneConfiguration = response.Configuration;

        this.cleanCloneConfiguration(cloneConfiguration);
        this.cleanCloneMachine(response.Machine);

        return response;
      });
  }
}
